import './App.css';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { AuthContext } from '../../Context/AuthContext'
import { NotifProvider } from '../../Context/NotifContext'
import Navigation from '../../Components/Navigation/Navigation'
import Footer from '../../Components/Footer/Footer';
import { useContext, useEffect } from 'react';
import { ThemeContext } from '../../Context/ThemeContext';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import Loader from '../../Shared/Loader/Loader';

const Home = lazy(() => import('../Home/Home'))
const Profile = lazy(() => import('../Profile/Profile'))
const SignIn = lazy(() => import('../SignIn/SignIn'))
const NewInvoice = lazy(() => import('../NewInvoice/NewInvoice'))
const MyInvoices = lazy(() => import('../MyInvoices/MyInvoices'))
const MyClients = lazy(() => import('../MyClients/MyClients'))
const MyData = lazy(() => import('../MyData/MyData'))
const ContactUs = lazy(() => import('../ContactUs/ContactUs'))
const RenderInvoice = lazy(() => import('../RenderInvoice/RenderInvoice'))

function App() {
  const authCtx = useContext(AuthContext)
  const Theme = useContext(ThemeContext)

  useEffect(() => {
    if (Theme.Theme.isDark) {
      document.body.classList.add('Dark');
    } else {
      document.body.classList.remove('Dark');
    }
  }, [Theme.Theme])

  const muiTheme = createMuiTheme({
    palette: {
      type: Theme.Theme.isDark ? 'dark' : 'light',
    },
  })

  const isUser = authCtx.auth.isUser

  // While auth state is still resolving (null), don't bounce the user to /signin.
  const guard = (component) => {
    if (isUser === null) return <div className="center-state"><Loader /></div>
    return isUser ? component : <Redirect to="/signin" />
  }

  return (
    <ThemeProvider theme={muiTheme}>
      <NotifProvider>
        <BrowserRouter>
          <Navigation />
          <main className="appMain">
            <Suspense
              fallback={
                <div className="center-state">
                  <Loader />
                </div>
              }
            >
              <Switch>
                <Route path="/profile">{guard(<Profile />)}</Route>
                <Route path="/newinvoice/:id">{guard(<NewInvoice />)}</Route>
                <Route path="/newinvoice">{guard(<NewInvoice />)}</Route>
                <Route path="/myinvoices">{guard(<MyInvoices />)}</Route>
                <Route path="/myclients">{guard(<MyClients />)}</Route>
                <Route path="/renderinvoice/:id">{guard(<RenderInvoice />)}</Route>
                <Route path="/renderinvoice">{guard(<RenderInvoice />)}</Route>
                <Route path="/contactus">{guard(<ContactUs />)}</Route>
                <Route path="/mydata">{guard(<MyData />)}</Route>
                <Route path="/signin"><SignIn /></Route>
                <Route exact path="/"><Home /></Route>
                <Route><Redirect to="/" /></Route>
              </Switch>
            </Suspense>
          </main>
          <Footer />
        </BrowserRouter>
      </NotifProvider>
    </ThemeProvider>
  );
}

export default App;
